import { render, staticRenderFns } from "./COD.vue?vue&type=template&id=fff8d3ee"
import script from "./COD.vue?vue&type=script&lang=js"
export * from "./COD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports